import React from "react";

import { STAGE_GOLD, stageRandom } from "./stageTokens";

/** Nón đèn rọi, vũng sáng, sàn gỗ, hàng bóng đèn mái và bụi bay trong luồng sáng. */
export function StageBackdrop({ budget }) {
    const blend = budget.mobile ? undefined : "screen";
    const bulbCount = budget.tier === "high" ? 16 : 8;
    const moteCount = budget.tier === "low" ? 0 : 7;

    return (
        <div
            aria-hidden
            style={{
                pointerEvents: "none",
                position: "absolute",
                inset: 0,
                zIndex: 0,
                overflow: "hidden"
            }}
        >
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "radial-gradient(ellipse 90% 60% at 50% 0%, rgba(60,30,40,0.0) 0%, rgba(10,5,9,0.55) 100%)"
                }}
            />

            {/* Nón sáng đổ xuống từ giàn đèn */}
            <div
                style={{
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    height: "78%",
                    width: "150%",
                    transform: "translateX(-50%)",
                    clipPath: "polygon(46% 0, 54% 0, 100% 100%, 0% 100%)",
                    background:
                        "linear-gradient(180deg, rgba(255,248,230,0.30) 0%, rgba(255,248,230,0.08) 42%, transparent 80%)",
                    mixBlendMode: blend,
                    opacity: 0.9
                }}
            />

            {/* Vũng sáng nơi nón đèn chạm đất */}
            <div
                style={{
                    position: "absolute",
                    left: "50%",
                    top: "34%",
                    height: "60%",
                    width: "150%",
                    transform: "translateX(-50%)",
                    background:
                        "radial-gradient(ellipse 42% 46% at 50% 30%, rgba(255,244,222,0.42) 0%, rgba(255,238,210,0.14) 40%, transparent 72%)",
                    mixBlendMode: blend
                }}
            />

            {/* Sàn gỗ */}
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "34%",
                    background:
                        "linear-gradient(180deg, #3a2018 0%, #2a1610 60%, #1c0e0a 100%)",
                    boxShadow: "inset 0 14px 30px rgba(0,0,0,0.5)"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: "34%",
                    height: 2,
                    background:
                        "linear-gradient(90deg, transparent, rgba(244,213,138,0.5), transparent)"
                }}
            />

            {/* Hàng bóng đèn mái */}
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    display: "flex",
                    justifyContent: "center",
                    gap: "3vw",
                    padding: "8px 16px 0"
                }}
            >
                {Array.from({ length: bulbCount }).map((_, i) => (
                    <span
                        key={i}
                        className={budget.loops ? "ac-bulb" : undefined}
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background: STAGE_GOLD,
                            boxShadow: `0 0 8px ${STAGE_GOLD}, 0 0 16px rgba(244,213,138,0.6)`,
                            animationDelay: budget.loops ? `${(i % 5) * 0.18}s` : undefined
                        }}
                    />
                ))}
            </div>

            {/* Hạt bụi bay trong luồng sáng */}
            {Array.from({ length: moteCount }).map((_, i) => (
                <span
                    key={i}
                    className={budget.loops ? "ac-mote" : undefined}
                    style={{
                        position: "absolute",
                        left: `${Math.round(38 + 24 * stageRandom(i, 5))}%`,
                        top: `${Math.round(12 + 50 * stageRandom(i, 8))}%`,
                        width: 3,
                        height: 3,
                        borderRadius: "50%",
                        background: "rgba(255,248,230,0.7)",
                        animationDelay: budget.loops
                            ? `${Math.round(40 * stageRandom(i, 3)) / 10}s`
                            : undefined
                    }}
                />
            ))}
        </div>
    );
}

/** Hàng đèn chân sân khấu chạy dọc mép dưới cùng. */
export function Footlights() {
    return (
        <div
            aria-hidden
            style={{
                pointerEvents: "none",
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
                height: 64,
                background: [
                    "radial-gradient(20px 16px at 10% 100%, #0a0507 60%, transparent 62%)",
                    "radial-gradient(22px 18px at 26% 100%, #0a0507 60%, transparent 62%)",
                    "radial-gradient(20px 16px at 42% 100%, #0a0507 60%, transparent 62%)",
                    "radial-gradient(24px 19px at 58% 100%, #0a0507 60%, transparent 62%)",
                    "radial-gradient(20px 16px at 74% 100%, #0a0507 60%, transparent 62%)",
                    "radial-gradient(22px 18px at 90% 100%, #0a0507 60%, transparent 62%)",
                    "linear-gradient(180deg, transparent, #0a0507 78%)"
                ].join(",")
            }}
        />
    );
}
